import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../auth/Login';
import Dashboard from '../Dashboard';
import Customers from '../Pages/Customers/Customers';
import AddCustomers from '../Pages/Customers/AddCustomers';
import { toast, ToastContainer } from 'react-toastify';
import Settings from '../Pages/Settings/Settings';
import Download from '../Pages/Download';
import PromOrders from '../Pages/PromOrder/PromOrders';
import AddPromOrder from '../Pages/PromOrder/AddPromOrder';
import Wedding from '../Pages/Wedding/Wedding';
import Delinquent from '../Pages/Delinquent';
import Inventory from '../Pages/Inventory';
import MapAffiliated from '../Pages/MapAffiliated';
import AddAffiliatedGroup from '../Pages/AddAffiliatedGroup';
import OrderReview from '../Pages/PromOrder/OrderReview';
import AddWedding from '../Pages/Wedding/AddWedding';
import WeddingOrderReview from '../Pages/Wedding/WeddingOrderReview';
import AddBrideDetail from '../Pages/Wedding/AddBrideDetail';
import AddStyleDetail from '../Pages/Wedding/AddStyleDetail';
import AddDescription from '../Pages/Wedding/AddDescription';
import AffiliatedDetail from '../Pages/AffiliatedDetail';
import SizeChart from '../Pages/Settings/SizeChart';
import AddComment from '../Pages/PromOrder/AddComment';
import AddMeasured from '../Pages/PromOrder/AddMeasured';
import MultiStepForm from '../Pages/Wedding/MultiStepForm';
import SingleOrder from '../Pages/SingleOrder.jsx/SingleOrder';
// import Test from '../Pages/Test';
import MultipleForm from '../Pages/SingleOrder.jsx/MultipleForm';
import FuneralOrder from '../Pages/FuneralOrder/FuneralOrder';
import OrderDetail from '../Pages/SingleOrder.jsx/OrderDetail';
import CoatPantSize from '../Pages/Settings/CoatPantSize';
import GroomStyle from '../Pages/Wedding/GroomStyle';
import FormParent from '../Pages/Wedding/AddGroom/FormParent';
import WeddingEventdetail from '../Pages/Wedding/AddGroom/WeddingEventdetail';
import Addmember from '../Pages/Wedding/AddGroom/Addmember';
import UpdateGroomMenStyle from '../Pages/Wedding/AddGroom/UpdateGroomMenStyle';
import MemberParent from '../Pages/Wedding/UpdateMember.jsx/MemberParent';
import MemberDetail from '../Pages/Wedding/AddGroom/MemberDetail';
import EmailEditor from '../Pages/Wedding/EmailEditor';
import AccountDetail from '../Pages/Settings/AccountDetails';
import ExportsData from '../Pages/Settings/ExportData';
import ForgetPassword from '../auth/ForgetPassword';
import Pricing from '../Pages/Pricing';
import Dropshipping from '../Pages/DropShipping/Dropshipping';
import EmailAlertSettings from '../Pages/Settings/EmailAlert';
// Protected Route wrapper component
const PrivateRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('token') !== null;
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Public Route wrapper component to prevent authenticated users from accessing login
const PublicRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('token') !== null;
    return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};



function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/login"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />

                <Route
                    path="/forgot-password"
                    element={
                        <PublicRoute>
                            <ForgetPassword />
                        </PublicRoute>
                    }
                />

                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/customers"
                    element={
                        <PrivateRoute>
                            <Customers />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/update-customers"
                    element={
                        <PrivateRoute>
                            <AddCustomers />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/create-customers"
                    element={
                        <PrivateRoute>
                            <AddCustomers />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/edit-profile"
                    element={
                        <PrivateRoute>
                            <Settings />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/account-details"
                    element={
                        <PrivateRoute>
                            <AccountDetail />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/export-data"
                    element={
                        <PrivateRoute>
                            <ExportsData />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/EmailEditor"
                    element={
                        <PrivateRoute>
                            <EmailEditor />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/drop-shipping"
                    element={
                        <PrivateRoute>
                            <Dropshipping />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/wedding"
                    element={
                        <PrivateRoute>
                            <Wedding />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/update-member"
                    element={
                        <PrivateRoute>
                            <MemberParent />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/add-order"
                    element={
                        <PrivateRoute>
                            <MultipleForm />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/update-single-order"
                    element={
                        <PrivateRoute>
                            <MultipleForm />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/update-GroomMen-Style"
                    element={
                        <PrivateRoute>
                            <UpdateGroomMenStyle />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/wedding-order-review"
                    element={
                        <PrivateRoute>
                            <WeddingOrderReview />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/add-bride-detail"
                    element={
                        <PrivateRoute>
                            <AddBrideDetail />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/add-style-detail"
                    element={
                        <PrivateRoute>
                            <AddStyleDetail />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/add-description"
                    element={
                        <PrivateRoute>
                            <AddDescription />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/map-affiliated-store"
                    element={
                        <PrivateRoute>
                            <MapAffiliated />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/add-affiliated-group/:type"
                    element={
                        <PrivateRoute>
                            <AddAffiliatedGroup />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/update-affiliated-group"
                    element={
                        <PrivateRoute>
                            <AddAffiliatedGroup />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/affiliated-detail"
                    element={
                        <PrivateRoute>
                            <AffiliatedDetail />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/order-detail"
                    element={
                        <PrivateRoute>
                            <OrderDetail />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/download"
                    element={
                        <PrivateRoute>
                            <Download />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/delinquent"
                    element={
                        <PrivateRoute>
                            <Delinquent />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/inventory"
                    element={
                        <PrivateRoute>
                            <Inventory />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/prom-orders"
                    element={
                        <PrivateRoute>
                            <PromOrders />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/add-prom-orders"
                    element={
                        <PrivateRoute>
                            <AddPromOrder />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/orders-review"
                    element={
                        <PrivateRoute>
                            <OrderReview />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/add-wedding-order"
                    element={
                        <PrivateRoute>
                            <FormParent />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/update-wedding-event"
                    element={
                        <PrivateRoute>
                            <FormParent />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/Member-detail"
                    element={
                        <PrivateRoute>
                            <MemberDetail />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/wedding-event-detail"
                    element={
                        <PrivateRoute>
                            <WeddingEventdetail />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/add-member"
                    element={
                        <PrivateRoute>
                            <Addmember />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/add-groom-Style-detail"
                    element={
                        <PrivateRoute>
                            <GroomStyle />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/size-ranges"
                    element={
                        <PrivateRoute>
                            <SizeChart />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/coat-pant-size"
                    element={
                        <PrivateRoute>
                            <CoatPantSize />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/prom-add-comment"
                    element={
                        <PrivateRoute>
                            <AddComment />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/prom-add-measured"
                    element={
                        <PrivateRoute>
                            <AddMeasured />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/single-order"
                    element={
                        <PrivateRoute>
                            <SingleOrder />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/funeral-order"
                    element={
                        <PrivateRoute>
                            <FuneralOrder />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/price-list"
                    element={
                        <PrivateRoute>
                            <Pricing />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/email-alert"
                    element={
                        <PrivateRoute>
                            <EmailAlertSettings />
                        </PrivateRoute>
                    }
                />

                <Route path="*" element={<Navigate to="/login" replace />} />

                <Route
                    path="/"
                    element={
                        localStorage.getItem('token') ?
                            <Navigate to="/dashboard" /> :
                            <Navigate to="/login" />
                    }
                />
            </Routes>
            <ToastContainer />
        </BrowserRouter>
    );
}

export default App;